<template>
  <page style="height: 100vh; overflow: hidden">
    <div class="borrow-warp">
      <div class="borrow-head">
        <img class="borrow-logo" src="@/assets/imgs/img_logo.png" />
      </div>
      <div class="borrow-body">
        <div class="borrow-title">{{ i18n.unlock_power_bank }}</div>
        <!-- <login-apple v-if="system === 'ios'" @success="loadUser()">
          <div class="borrow-login-btn" id="sign-in-with-apple-button">
            <img src="@/assets/imgs/icon_apple.png" alt="">
            <span>Apple</span>
          </div>
        </login-apple> -->
        <div v-if="user" class="borrow-login-user">
          <img
            v-if="user.popenId.indexOf('apple') > -1"
            src="@/assets/imgs/icon_apple.png"
            alt=""
          />
          <img
            v-else-if="user.popenId.indexOf('google') > -1"
            src="@/assets/imgs/icon_google.png"
            alt=""
          />
          <img v-else src="@/assets/imgs/icon_phone.png" alt="" />
          <span>{{ user.pname }}</span>
        </div>
        <template v-else>
          <login-google @success="loadUser">
            <div class="borrow-login-btn" id="buttonDiv"></div>
          </login-google>
          <div class="borrow-login-other">
            <span @click="isOtherLogin = true">{{ i18n.other_options }}</span>
          </div>
        </template>

        <div class="borrow-sub-title">{{ i18n.select_payment }}</div>

        <PaymentMethods
          ref="PaymentMethods"
          :qrcode="cabinet.qrcode"
          :productId="cabinet.productId"
          :orderId="orderId"
          :amount="amount"
          payType="YJ"
        ></PaymentMethods>

        <div class="borrow-sub-title">{{ i18n.payment_method }}</div>
        <div class="borrow-deposit">
          <img
            class="borrow-deposit-icon"
            src="@/assets/imgs/icon_pay.png"
            alt=""
          />
          <div class="borrow-deposit-label">
            {{ i18n.pre_authorisation }} {{ cabinet.currencyName }}
            {{ cabinet.yajin }}
          </div>
          <img
            class="borrow-deposit-info"
            src="@/assets/imgs/icon_info.png"
            @click="isAboutPreAuth = true"
            alt=""
          />
        </div>
        <div class="borrow-sub-title">{{ i18n.coupon_code }}</div>
        <div class="borrow-deposit">
          <img
            class="borrow-deposit-icon"
            src="@/assets/imgs/icon_coupon.png"
            alt=""
          />
          <div class="borrow-deposit-label">
            <input
              type="text"
              v-model="couponCode"
              :placeholder="i18n.coupon_code"
            />
          </div>
        </div>
        <div class="borrow-cabinet">
          <img
            class="borrow-cabinet-icon"
            src="@/assets/imgs/icon_cabinet.png"
            alt=""
          />
          <div class="borrow-cabinet-cont" @click="rentCostShow = true">
            <div class="borrow-cabinet-row">
              <span class="borrow-cabinet-price"
                >{{ cabinet.currencyName }}{{ $moneyFormat(cabinet.jifei) }}
                {{ i18n.per }} {{ cabinet.jifeiDanwei }}
                {{
                  $priceUnit(
                    (cabinet.priceStrategy &&
                      cabinet.priceStrategy.priceUnit) ||
                      0,
                    cabinet.jifeiDanwei
                  )
                }}</span
              >
              <img
                class="borrow-deposit-icon"
                src="@/assets/imgs/icon_more.png"
                alt=""
              />
            </div>
            <div class="borrow-cabinet-row">
              <span class="borrow-cabinet-max"
                >{{ cabinet.currencyName }}{{ cabinet.fengding }} {{ i18n.max
                }}{{ i18n.per_day }}</span
              >
              <span class="borrow-cabinet-link">{{ i18n.all_pricing }}</span>
            </div>
          </div>
        </div>
        <div class="btn borrow-btn" @click="onSubmit">{{ i18n.next }}</div>
      </div>
    </div>
    <Login v-model="isOtherLogin"></Login>
    <AboutPreAuth v-model="isAboutPreAuth"></AboutPreAuth>
    <RentCostTip
      v-if="rentCostShow"
      :type="cabinet.priceStrategy.pType || 1"
      :jifei="cabinet.priceStrategy.pPrice || 2"
      :jifeiDanwei="
        cabinet.priceStrategy.priceUnit || cabinet.jifeiDanwei || 60
      "
      :fengding="cabinet.priceStrategy.pDayAmount || 6"
      :yajin="cabinet.yajin"
      :currencyName="cabinet.currencyName"
      :currency="cabinet.currency"
      :priceStrategyDetail="cabinet.priceStrategy.priceStrategyDetail"
      :overtimeAmount="cabinet.priceStrategy.pOvertimeAmount"
      :priceUnit="cabinet.priceStrategy.priceUnit"
      @close="res => (rentCostShow = res)"
    ></RentCostTip>
  </page>
</template>

<script>
import { mapState } from "vuex";
import PaymentMethods from "@/components/payment/PaymentMethods";
import { LoginGoogle } from "@/components/login";
import { USER_INFO, CONPON_SEND, INVITE_CODE } from "@/apis/user.js";
import Login from "./components/Login";
import AboutPreAuth from "./components/AboutPreAuth";
import RentCostTip from "./components/rentcosttip.vue";
import cabinetMixin from "../../mixins/cabinet";

export default {
  mixins: [cabinetMixin],
  components: {
    PaymentMethods,
    LoginGoogle,
    Login,
    AboutPreAuth,
    RentCostTip
  },
  computed: {
    ...mapState([
      "qrcode",
      "zhcode",
      "cabinet",
      "browser",
      "user",
      "token",
      "system"
    ]),
    i18n() {
      return this.$t("borrow");
    },
    amount() {
      if (this.cabinet) {
        const { yajin, myyue, overtimeAmount } = this.cabinet;
        let _amount = yajin.toFixed(2);
        if (yajin <= 0 && overtimeAmount <= 0) {
          _amount = (yajin - myyue).toFixed(2);
        }
        return _amount;
      } else {
        return 0;
      }
    }
  },
  data() {
    return {
      orderId: "",
      isOtherLogin: false,
      isAboutPreAuth: false,
      rentCostShow: false,
      couponCode: ""
    };
  },
  methods: {
    loadUser() {
      this.$get(
        USER_INFO,
        {},
        res => {
          if (res.user) {
            this.$store.commit("user", res.user);
            this.$toast(this.i18n.msg_success_login);
          } else {
            this.$store.commit("user", null);
            this.$store.commit("token", null);
          }
        },
        err => {
          console.log(err);
          this.$store.commit("user", null);
          this.$store.commit("token", null);
        }
      );
    },
    async getCoupon() {
      this.$loading(true);
      try {
        await this.$Request("post", INVITE_CODE, {
          inviteCode: this.couponCode
        });
        this.$loading(false);
        this.submitPayment();
      } catch (e) {
        console.log(e);
        try {
          await this.$Request(
            "post",
            `${CONPON_SEND}?code=${this.couponCode}`,
            {}
          );
          this.$loading(false);
          this.$rsubmitPayment();
        } catch (e) {
          console.log(e);
          this.$loading(false);
          this.submitPayment();
        }
      }
    },
    submitPayment() {
      let myyue = this.cabinet.myyue;
      let yajin = 0.0;
      let overtimeAmount = 0.0;
      if (
        this.cabinet.priceStrategy != null &&
        this.cabinet.priceStrategy.pId != null
      ) {
        yajin = this.cabinet.priceStrategy.pDepositAmount;
        overtimeAmount = this.cabinet.priceStrategy.pOvertimeAmount;
      } else {
        yajin = this.cabinet.yajin;
        overtimeAmount = this.cabinet.overtimeAmount ?? this.cabinet.yajin;
      }
      console.log("🚀 ~ yajin:", myyue, yajin, overtimeAmount);
      if (myyue >= yajin && myyue >= overtimeAmount) {
        this.onUseBalanceToRent(this.rentalProductType(this.cabinet));
      } else {
        this.$refs.PaymentMethods.onPay();
      }
    },
    onSubmit() {
      if (!this.user) {
        this.$toast(this.i18n.login_tips);
        return;
      }
      if (this.couponCode && this.couponCode.length > 4) {
        this.getCoupon();
      } else {
        this.submitPayment();
      }
    }
  },
  created() {
    if (!this.cabinet) {
      this.$router.push("/");
    } else {
      this.loadUser();
    }
  }
};
</script>

<style lang="less" scoped>
.borrow-warp {
  height: 100vh;
  background-color: #f0f1f3;
  display: flex;
  flex-direction: column;
  .borrow-head {
    padding: 42px 0;
    .borrow-logo {
      display: block;
      width: 274px;
      margin: 0 auto;
    }
  }
  .borrow-body {
    flex: 1;
    border-radius: 100px 100px 0 0;
    background-color: #fff;
    padding: 52px 48px;
    overflow: auto;
    .borrow-title {
      font-size: 44px;
      padding-bottom: 50px;
    }
    .borrow-login-user {
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 28px;
      color: #171917;
      background-color: rgba(242, 252, 127, 0.3);
      border-radius: 20px;
      img {
        height: 40px;
        display: block;
        margin-right: 24px;
      }
    }
    .borrow-login-btn {
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 28px;
      color: #171917;
      border: 1px solid #ebebeb;
      border-radius: 20px;
      img {
        height: 40px;
        display: block;
        margin-right: 24px;
      }
    }
    .borrow-login-other {
      display: flex;
      justify-content: center;
      padding-top: 30px;
    }
    .borrow-sub-title {
      font-size: 32px;
      color: #171917;
      padding: 50px 0 24px;
    }
    .borrow-deposit {
      height: 98px;
      border: 1px solid #ebebeb;
      border-radius: 20px;
      padding: 0 32px;
      display: flex;
      align-items: center;
      .borrow-deposit-icon {
        width: 38px;
        display: block;
        margin: 0;
      }
      .borrow-deposit-label {
        padding: 0 20px;
        flex: 1;
        input {
          height: 80px;
          padding: 0;
          margin: 0;
          width: 100%;
          border: none;
        }
      }
      .borrow-deposit-info {
        width: 34px;
        display: block;
        margin: 0;
      }
    }
    .borrow-cabinet {
      margin-top: 59px;
      position: relative;
      .borrow-cabinet-icon {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 96px;
      }
      .borrow-cabinet-cont {
        height: 98px;
        padding: 22px 18px 0 106px;
        background-color: #f2f2f2;
        border-radius: 20px;
      }
      .borrow-cabinet-row {
        display: flex;
        justify-content: space-between;
        .borrow-cabinet-price {
          color: #000;
          font-size: 28px;
        }
        .borrow-cabinet-max {
          color: #666666;
          font-size: 24px;
        }
        .borrow-cabinet-link {
          color: #000;
          font-size: 24px;
        }
        .borrow-deposit-icon {
          width: 40px;
          height: 40px;
        }
      }
    }
    .borrow-btn {
      margin: 60px 0 40px;
    }
  }
}
</style>
